import React from 'react'
import { observer } from 'mobx-react'
import { Loading } from '@winnin/winnin_ui.components.loading'

import AddVideoToCheckBox from 'components/AddVideoToCheckbox'
import BlockComponentsRole75Checker from 'components/BlockComponentsRole75Checker'
import LivePostTag from 'components/LivePostTag'
import Thumbnail from 'components/Thumbnail'
import { T } from 'lib/tolgee'
import { UserStore, VideoModalStore } from 'stores'

function VideoHighlight({ mostLikedVideo, title }) {
  const isViewerUser = UserStore.getRole === 'viewer'

  const handleVideoClick = () => {
    if (mostLikedVideo?.live?.state === 'scheduled') {
      return
    }

    const formattedVideos = {
      postId: mostLikedVideo.postId,
      provider: mostLikedVideo.provider,
    }

    VideoModalStore.setVideo({ currentVideo: formattedVideos })
  }

  return mostLikedVideo ? (
    <div onClick={handleVideoClick} className="CreatorCard-highlight-right-video">
      <BlockComponentsRole75Checker className="pin-block-card" isClickBlocked={isViewerUser}>
        <AddVideoToCheckBox
          id={mostLikedVideo.postId}
          provider={mostLikedVideo.provider}
          thumbnail={mostLikedVideo.thumbnail}
          title={mostLikedVideo.title}
          creatorName={mostLikedVideo?.creator?.title}
        />
      </BlockComponentsRole75Checker>
      <LivePostTag live={mostLikedVideo?.live} />
      <Thumbnail height={173} src={mostLikedVideo.thumbnail} />
      <p>{mostLikedVideo.title}</p>
      <p className="caption">
        <T keyName="CreatorCard_VideoHighlight-videoCaption" parameters={{ title }}>
          {'Most liked video of {title} in this topic'}
        </T>
      </p>
    </div>
  ) : (
    <Loading />
  )
}

export default observer(VideoHighlight)
